import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksMaterialProductionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].getWorksMaterialProductionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBaseWorksMaterialProductionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].getBaseWorksMaterialProductionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedWorksMaterialProductionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].getExtendedWorksMaterialProductionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function createWorksMaterialProductionRateNorm(companyId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].createWorksMaterialProductionRateNorm,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function getWorksMaterialProductionRateNorm(companyId, worksMaterialProductionRateNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].getWorksMaterialProductionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialProductionRateNormId,
			},
		},
	)
}

function patchWorksMaterialProductionRateNorm(companyId, worksMaterialProductionRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].patchWorksMaterialProductionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialProductionRateNormId,
			},
			...data,
		},
	)
}

function putWorksMaterialProductionRateNorm(companyId, worksMaterialProductionRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].putWorksMaterialProductionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialProductionRateNormId,
			},
			...data,
		},
	)
}

function deleteWorksMaterialProductionRateNorm(companyId, worksMaterialProductionRateNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS].deleteWorksMaterialProductionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialProductionRateNormId,
			},
		},
	)
}

export default {
	getWorksMaterialProductionRateNorms,
	getBaseWorksMaterialProductionRateNorms,
	getExtendedWorksMaterialProductionRateNorms,
	getWorksMaterialProductionRateNorm,
	patchWorksMaterialProductionRateNorm,
	putWorksMaterialProductionRateNorm,
	createWorksMaterialProductionRateNorm,
	deleteWorksMaterialProductionRateNorm,
}